import { useDispatch } from "react-redux";
import {
  selectUserToken,
  selectUserWebsitePermissions,
  setDisplayErrorSnackBar,
} from "../features/userSlice";
import { useMemo, useState } from "react";
import { PackagesEndPointLogic } from "../logic/DataCollection/Monitoring/PackagesEndPointLogic";
import { useSelector } from "react-redux";
import { setIsPackagesLoading } from "../features/monitoringPackagesSlice";

export const useMonitoringPackages = () => {
  const websitePermissions = useSelector(selectUserWebsitePermissions) as any; // Get user website permissions
  const query_id = 5652708983832576;
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const { queryBizLayerData } = useSelector(
    (state: any) => state.monitoringPackages
  );

  /*
        new Map(...)
        You are creating a new JavaScript Map object
        A Map stores key-value pairs and allows fast lookups using .get(key)

      --- Get Brand List(Brand Id and Brand Name)
  */
  const brandMap = useMemo(
    () =>
      new Map(
        queryBizLayerData?.map((item: any) => [
          String(item.brand_id),
          item.brand_name,
        ]) || []
      ),
    [queryBizLayerData]
  );

  //-- Function to get Brand Name from a specific brand_id
  function getBrandName(brandId: string | number): string | undefined | any {
    return brandMap.get(String(brandId));
  }

  //-- Function to get list of websites(site_name with site_id) (used for passing the site_id to the API)
  const siteNameToIdMap = useMemo(() => {
    return websitePermissions?.reduce((acc: any, item: any) => {
      const id = Object.keys(item)[0];
      const site_name = item[id].ui_site_name;
      acc[site_name] = id;
      return acc;
    }, {});
  }, [websitePermissions]);

  const targetSite = "bestbookiesandbettingsites";
  const website_shared_uid =
    siteNameToIdMap[targetSite] || Object.values(siteNameToIdMap)[0];

//-- Function to fetch all monitoring packages
  const fetchMonitoringPackages = async (
  from_date: any,
  to_date: any,
  rpp?: any,
  page?: any,
  previousList?: any[],
  filters?: {
    status?: string[];
    process_id?: string[]; // Changed from process_name to process_id
    package_name?: string[];
    brand_id?: string[];
    interface_id?: string[];
  }
): Promise<number> => {
  dispatch(setIsPackagesLoading(true));

  try {
    // Prepare cleaned filters (remove undefined/empty values)
    const cleanedFilters = filters
      ? Object.fromEntries(
          Object.entries(filters).filter(
            ([_, value]) =>
              value !== undefined &&
              value !== null &&
              (Array.isArray(value) ? value.length > 0 : true)
          )
        )
      : undefined;

    // Run both API calls in parallel
    const [, packageResponse] = await Promise.all([
      PackagesEndPointLogic.getQueryBizLayer(
        oauthTokenHeader,
        query_id,
        website_shared_uid,
        from_date,
        to_date,
        dispatch
      ),
      PackagesEndPointLogic.getAllPackageList(
        oauthTokenHeader,
        from_date,
        to_date,
        dispatch,
        rpp,
        page,
        previousList || [],
        cleanedFilters
      ),
    ]);

    const count = packageResponse?.data?.valid_records?.length || 0;
    return count;
  } catch (error) {
    const errorMessage =
      typeof error === "string"
        ? error
        : error instanceof Error
        ? error.message
        : "An unexpected error occurred.";

    dispatch(
      setDisplayErrorSnackBar({ message: errorMessage, type: "error" })
    );
    return 0;
  } finally {
    setIsLoading(false);
    dispatch(setIsPackagesLoading(false));
  }
};
  return {
    getBrandName,
    fetchMonitoringPackages,
    isLoading,
  };
};
